import getSymbolFromCurrency from "currency-symbol-map";
import { TENANT, TenantService } from "../../managers/TenantManagerService";
import FormatCurrencyService from "../../services/FormatCurrencyService";
import { Subject } from "rxjs";

const DEFAULT_UNMASK_LEN = 4;

class MaskInputUtil {
    static MASK_CHARS = "******";
    static REPLACE_CHAR = "*";
    static MASKED_NUMBER_REGEX = new RegExp("[0-9]", "g");
    static MASKED_TEXT_REGEX = new RegExp("[A-Za-z0-9]", "g");

    static SHOW_MASK_UNMASK_BUTTON_SUBJECT = new Subject();
    static MASK_UNMASK_SUBJECT = new Subject();
    static MASK_STATE = true;

    static getMaskedText(showMask = true, inputText, unmaskLen = DEFAULT_UNMASK_LEN) {
        if (showMask && (typeof inputText === "string" || typeof inputText === "number")) {
            inputText = String(inputText);
            if (inputText && inputText !== "[object Object]" && inputText.length > unmaskLen) {
                const maskedText = inputText.substring(0, inputText.length - unmaskLen).replace(MaskInputUtil.MASKED_TEXT_REGEX, MaskInputUtil.REPLACE_CHAR);
                return maskedText.concat(inputText.substring(inputText.length - unmaskLen));
            }
        }

        return inputText;
    }

    static getMaskedNumber(showMaskText, inputNumber) {
        if (!showMaskText) {
            return FormatCurrencyService.format(inputNumber);
        }

        if (TenantService.get(TENANT.CUSTOM_FIELD_SECTION_ENABLED)) {
            return `${getSymbolFromCurrency(TenantService.get(TENANT.CURRENCY_CODE)) ?? ""}${MaskInputUtil.MASK_CHARS}`;
        } else {
            return FormatCurrencyService.format(inputNumber).replace(MaskInputUtil.MASKED_NUMBER_REGEX, MaskInputUtil.REPLACE_CHAR);
        }
    }

    static subscripeToShowMaskUnmaskButtonObservable() {
        return MaskInputUtil.SHOW_MASK_UNMASK_BUTTON_SUBJECT.asObservable();
    }

    static subscripeToMaskUnmaskObservable(updateState) {
        MaskInputUtil.SHOW_MASK_UNMASK_BUTTON_SUBJECT.next(true);
        return MaskInputUtil.MASK_UNMASK_SUBJECT.asObservable().subscribe(
            (mask) => {
                updateState(mask);
            }
        );
    }

    static updateMaskUnmaskStatus(mask) {
        MaskInputUtil.MASK_STATE = mask;
        MaskInputUtil.MASK_UNMASK_SUBJECT.next(mask);
    }

    static unsubscribe(observable) {
        MaskInputUtil.SHOW_MASK_UNMASK_BUTTON_SUBJECT.next(false);
        if (observable) {
            observable.unsubscribe();
        }
    }
}

export default MaskInputUtil;
